import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService, InvoiceItem } from 'src/app/Api_Module';
import { FindInvoiceByBookingCodeResult } from 'src/app/Api_Module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'crg-invoice',
  templateUrl: './invoice.component.html'
})
export class InvoiceComponent implements OnInit {
  searchStr: string;
  invoice: FindInvoiceByBookingCodeResult = {} as FindInvoiceByBookingCodeResult;
  shownew = false;
  loading = false;
  messages = { emptyMessage: 'No Items found. Add new', totalMessage: 'Total Items' };
  items:string[]=[];
  item:InvoiceItem ={} as InvoiceItem;
  constructor(private invoiceService: InvoiceService, private modalService: NgbModal) { }
  ngOnInit() {
    this.items.push('License Disk Renewal');
    this.items.push('Petrol fill-up');
    this.items.push('Dry Cleaning');
    this.items.push('Shoe Repairs');
    this.items.push('Groceries');
    this.items.push('Flowers');
    this.items.push('Service');
    this.items.push('Scratch Mobile');
    this.item.id =0;
  }
  findInvoice() {
    this.invoiceService.getInvoice(this.searchStr).subscribe((resp: FindInvoiceByBookingCodeResult) => {
      if (resp) {
        this.invoice = resp;
        if (this.invoice.id == 0) {
          this.shownew = true;
        }
      }
    });
  }
  add()
  {
    this.invoice.items.push(this.item);
    this.invoice.items =[...this.invoice.items];
    this.invoice.total = parseFloat(this.invoice.total.toString()) + parseFloat(this.item.price.toString());
    this.item={} as InvoiceItem;
    this.item.id = this.invoice.items.length + 1;
    
  }

}
